// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"page-primaryButton-36Rben","wrapper":"page-wrapper-2hTCar","pageHeader":"page-pageHeader-1EXrfX"};